import React from "react";
import ReturnButton from "./ReturnButton";

const LEMUR_URL =
  "https://play.google.com/store/apps/details?id=com.lemurbrowser.exts&pcampaignid=web_share";

const KIWI_URL =
  "https://apkpure.com/kiwi-browser-fast-quiet/com.kiwibrowser.browser";

const CHROME_WEBSTORE_URL =
  "https://chromewebstore.google.com/detail/vrepop/depkoiepmnjkkbpcimmfhfndjjbbpkbl";

const YOUTUBE_VIDEO_URL =
  "https://www.youtube.com/embed/IAfaYbXVMuY";

export default function InstallAndroid() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50">
      <ReturnButton />

      <div className="bg-white p-8 rounded-xl shadow-lg max-w-3xl w-full">
        <h1 className="text-3xl font-bold mb-4 text-blue-600 text-center">
          Installer V-repop sur Android
        </h1>

        <p className="text-center text-gray-600 mb-6">
          ✔ Testé et validé : republication complète fonctionnelle sur Lemur Browser.
        </p>

        <ol className="list-decimal list-inside space-y-4 text-gray-700 text-base mb-8">
          <li>
            Installez <b>Lemur Browser</b> depuis le Play Store en cliquant{" "}
            <a
              href={LEMUR_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline font-medium"
            >
              ici
            </a>.
          </li>

          <li>
            Ouvrez Lemur puis accédez au Chrome Web Store.
          </li>

          <li>
            Recherchez <b>Vrepop</b> et installez l’extension.
          </li>

          <li>
            Connectez-vous à votre compte Vinted et ouvrez la page affichant toutes vos annonces.
          </li>

          <li>
            Le widget <b>V-repop</b> apparaît automatiquement.
          </li>

          <li>
            Configurez vos options puis utilisez le bouton <b>“Republier”</b>.
          </li>
        </ol>

        <div className="text-center mb-8">
          <a
            href={CHROME_WEBSTORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg font-semibold transition"
          >
            Ouvrir Vrepop sur le Chrome Web Store
          </a>
        </div>

        {/* Vidéo démonstration */}
        <div className="mb-8">
          <h2 className="text-xl font-bold mb-4 text-center">
            🎥 Démonstration sur Android
          </h2>

          <div className="w-full">
            <iframe
              className="w-full h-96 rounded-lg shadow-md"
              src={YOUTUBE_VIDEO_URL}
              title="Tutoriel Vrepop Android"
              frameBorder="0"
              allowFullScreen
            />
          </div>
        </div>

        <div className="text-sm text-gray-500 text-center">
          Alternative : si Lemur ne fonctionne pas sur votre appareil, vous pouvez utiliser{" "}
          <a
            href={KIWI_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            Kiwi Browser
          </a>{" "}
          (installation via APK externe).
        </div>
      </div>
    </div>
  );
}